<template>
    <div>
        <!-- MD、LG、XL 時顯示 -->
        <div class="d-none d-md-block d-lg-block d-xl-block">
            <img :src="$config.getAssetsURL('img/brand/Agri_Line.png')" class="agri-speech-img" />
            <div class="agri-speech-info">
                <div class="speech-bubble">
                    <!-- 阿龜小提示 -->
                    {{ $t('menu.agri_reminder') }}
                    <i class="fa fa-lightbulb-o"></i>
                    <br>
                    <div v-html="info"></div>
                </div>
            </div>
        </div>
        

        <!-- XS、SM 時顯示 -->
        <b-row align-v="center" class="d-md-none d-lg-none d-xl-none">
            <b-col cols=3 sm=2 class="text-right">
                <img :src="$config.getAssetsURL('img/brand/Agri_Line.png')" class="agri-speech-img" />
            </b-col>
            <b-col cols=9 sm=8>
                <div class="agri-speech-info">
                    <div class="speech-bubble">
                        {{ $t('menu.agri_reminder') }}
                        <i class="fa fa-lightbulb-o"></i>
                        <br>
                        <div v-html="info"></div>
                    </div>
                </div>
            </b-col>
        </b-row>
        
    </div>
</template>

<script>
export default {
    props: {
        info: {
            type: String,
            default: '',
        },
    }
}
</script>

<style lang="scss" scoped>

.agri-speech-img
{
    display: inline-block;
    vertical-align: middle;
    width: 100%;
    max-width: 80px;
    min-width: 50px;
    // width: 80px;
    margin: 10px;
    border-radius: 8px;
}

.agri-speech-info
{
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;

    .fa-lightbulb-o
    {
        color: #eed545;
        font-size: 1.5rem;
    }
}


// Speech Bubble
$speech-bubble-bg-color: rgba(83, 158, 160, 0.8); //#cebab7; //#a9cea7;
.speech-bubble
{
	// layout
	position: relative;
	
	// looks
	color: #ffffff;
	background-color: $speech-bubble-bg-color;
    padding: 1.125rem 1.5rem;
    margin: 15px 0px 20px 0px;
	font-size: 1.15rem;
    border-radius: 8px;
    
    
	-webkit-box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
	box-shadow: 0px 5px 25px 0px rgba(0, 0, 0, 0.2);
}
.speech-bubble::before
{
	// layout
	content: '';
	position: absolute;
	left: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 1.2rem solid transparent;
	border-right-color: $speech-bubble-bg-color;
    border-left: none;
	margin-top: -4%;//-10px;
	margin-left: -1.2rem;
}

</style>